/*
 * Created on Tue Aug 26 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

import { Vue } from "vue-property-decorator";
import { Retrier } from "@/../core/utilities/retrier";
import { Meta } from "@/../core/utilities/meta";
import { Observable, timer } from "rxjs";

declare module "vue/types/vue" {
    export interface Vue {
        $form(ref: string, key?: string): any;
        $vref(ref: string, key?: string, promise?: boolean): any | Promise<any>;
    }
}

const VREF_RETRIER = "__vref__retrier";

export const FormPlugin = {
    install: function (Vue: any) {
        if (Vue._val_form_installed) return;
        Vue._val_form_installed = true;

        Vue.mixin({
            methods: {
                /// if promise = true, return a promise to fire when dom ready
                $vref: function (
                    this: Vue,
                    ref: string,
                    key?: string,
                    promise?: boolean,
                ): any {
                    let me: any = this;

                    /// create the retrier.
                    /// do force update until the DOM ready
                    if (!me[VREF_RETRIER]) {
                        me[VREF_RETRIER] = new Retrier(() => {
                            me[VREF_RETRIER].stop();
                            let watchRef = (me.$refs[ref] || {})._uid;
                            if (!watchRef || me._watchRef == watchRef) return;
                            me._watchRef = watchRef;
                            /// recover the link
                            this.$forceUpdate();
                        }, 0);
                    }

                    /// link to form
                    if (!me.$refs[ref]) {
                        /// if promise, create the set!
                        if (promise) {
                            let resolve, reject;
                            let prom = new Promise((res, rej) => {
                                (resolve = res), (reject = rej);
                            });
                            let o = Meta.get(new Set([this, ref, key]));
                            o.promises = o.promises || [];
                            o.promises.push({ resolve, reject });

                            /// retry start
                            let count = 0;
                            let retrier = new Retrier(() => {
                                count++;
                                if (!me.$refs[ref]) {
                                    if (count >= 30) {
                                        retrier.stop();
                                        let o = Meta.get(new Set([this, ref, key]));
                                        if (o.promises && o.promises.length > 0) {
                                            while (o.promises.length > 0) {
                                                o.promises.pop().reject();
                                            }
                                        }
                                    }
                                    return;
                                }
                                /// finally get it
                                retrier.stop();
                                /// resolve promises
                                this.$vref(ref, key);
                            }, 1);
                            retrier.start();

                            return prom;
                        } else {
                            /// do next tick
                            me[VREF_RETRIER].restart();
                        }
                        return;
                    }

                    /// calculate result
                    let result = (this.$refs || {})[ref];
                    if (result == null) return null;
                    do {
                        if (!key) break;
                        for (let k of key.split(".")) {
                            result = result?.[k];
                            if (result == null) break;
                        }
                    } while (0);

                    /// try resolve promise!
                    let o = Meta.get(new Set([this, ref, key]));
                    if (o.promises && o.promises.length > 0) {
                        while (o.promises.length > 0) {
                            o.promises.pop().resolve(result);
                        }
                    }

                    return result;
                },

                $form: function (this: Vue, ref: string, key?: string): any {
                    // key = !key ? "result" : `result.${key}`;
                    // return this.$vref(ref, key);

                    var me: any = this;
                    /// link to form
                    if (!me.$refs[ref]) {
                        /// do next tick
                        setTimeout(() => {
                            let watchRef = (me.$refs[ref] || {})._uid;
                            if (!watchRef || me._watchRef == watchRef) return;
                            me._watchRef = watchRef;
                            /// recover the link
                            this.$forceUpdate();
                        }, 0);
                        return;
                    }

                    /// calculate result
                    let result = (<any>((this.$refs || {})[ref] || {})).result;
                    if (result == null) return null;
                    while (result instanceof Vue) {
                        result = result.result;
                    }
                    if (result == null) return null;
                    if (!key) return result;

                    for (let k of key.split(".")) {
                        result = result[k];
                        if (result == null) return null;
                    }
                    return result;
                },
            },
        });
    },
};
